module.exports = __webpack_public_path__ + "img/Group 1316.9ead664f.png";